import { TooltipProps as TooltipPropsMui } from '@mui/material';
import { StyledTooltip } from './Tooltip.styles';

export type TooltipProps = TooltipPropsMui;

export function Tooltip({ ...rest }: TooltipProps) {
  return <StyledTooltip {...rest} />;
}
